import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function CookieSettingsButton() {
  const [ready, setReady] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const check = setInterval(() => {
      if (window.Optanon && typeof window.Optanon.InitializeBanner === "function") {
        // Re-scan DOM and attach handlers
        window.Optanon.InitializeBanner();

        setReady(true);
        clearInterval(check);
      }
    }, 300);

    return () => clearInterval(check);
  }, []);

  if (!ready) return null;

  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window.Optanon.ToggleInfoDisplay === "function") {
          window.Optanon.ToggleInfoDisplay();
        }
      }}
      style={{ display: "inline-block" }}
    >
      {t("cookie_settings_link")}
    </button>
  );
}
